export interface PendingWorkspaceCreation {
  idempotencyKey: string;
  name: string | undefined;
  locale: string | undefined;
}

export function pendingWorkspaceCreationKey(
  serverId: string,
  accountId: string | undefined
): string {
  return `workspace-create-pending:${serverId}:${accountId ?? 'anonymous'}`;
}

export function readPendingWorkspaceCreation(
  value: unknown
): PendingWorkspaceCreation | undefined {
  if (
    !value ||
    typeof value !== 'object' ||
    typeof (value as PendingWorkspaceCreation).idempotencyKey !== 'string'
  ) {
    return undefined;
  }
  const pending = value as PendingWorkspaceCreation;
  if (
    !(pending.name === undefined || typeof pending.name === 'string') ||
    !(pending.locale === undefined || typeof pending.locale === 'string')
  ) {
    return undefined;
  }
  return pending;
}

export function resolveWorkspaceCreationAttempt(
  pending: PendingWorkspaceCreation | undefined,
  name: string | undefined,
  locale: string | undefined,
  createId: () => string = () => crypto.randomUUID()
): PendingWorkspaceCreation {
  return pending && pending.name === name && pending.locale === locale
    ? pending
    : { idempotencyKey: createId(), name, locale };
}
